/**
 * holds filters tree
 */
const findInQuery = (rules, searchTrim) =>
  rules.some(r => {
    if (r.group) return findInQuery(r.group.rules, searchTrim);
    const val = r.label || r.value;
    return val && val.toLowerCase().indexOf(searchTrim) !== -1;
  });

export class FiltersService {
  constructor(
    $q,
    FilterResource,
    globalAlert,
  ) {
    this.$q = $q;
    this.FilterResource = FilterResource;
    this.globalAlert = globalAlert;
    this.filters = [];
    this.loading = false;
  }

  searchFilters(predicate) {
    const searchedFilters = {
      all: !predicate
    };
    if (!predicate) return searchedFilters;

    const findIter = (filters) => {
      let foundFilter = false;
      filters.map(f => {
        if (predicate(f)) {
          searchedFilters[f.id] = true;
          foundFilter = true;
        }
        if (f.children && f.children.length) {
          if (findIter(f.children)) {
            searchedFilters[f.id] = true;
            foundFilter = true;
          }
        }
      });
      return foundFilter;
    };
    findIter(this.filters);
    return searchedFilters;
  }

  searchFiltersTrim(searchTrim) {
    return this.searchFilters(
      f => {
        if (f.query && f.query.rules && f.query.rules.length)
          console.log(f.query);
        return (
          f.name.toLowerCase().indexOf(searchTrim) !== -1 ||
          (f.emails && f.emails.toLowerCase().indexOf(searchTrim) !== -1) ||
          (f.filters &&
            f.filters.some(cut => {
              const val = cut.label || cut.value;
              if (val) return val.toLowerCase().indexOf(searchTrim) !== -1;
              return false;
            })) ||
          (f.query &&
            f.query.rules &&
            f.query.rules.length &&
            findInQuery(f.query.rules, searchTrim))
        );
      }
    );
  }


  load() {
    return this.$q.resolve()
      .then(() => {
        this.loading = true;
        return this.FilterResource.list();
      })
      .then(filters => {
        this.filters = filters;
      })
      .finally(() => {
        this.loading = false;
      });
  }

  save(filter) {
    const flt = angular.copy(filter);
    delete flt.dIndex;
    return this.FilterResource.save(flt)
      .then(({
        status,
        data,
        error
      }) => {
        if (error) {
          this.globalAlert(error.message);
          return;
        }
        const originalFilter = this.findById(data.id);
        Object.assign(filter, data);
        if (originalFilter) {
          Object.keys(originalFilter).map(k => delete originalFilter[k]);
          Object.assign(originalFilter, data);
        } else if (!filter.dIndex) this.filters.push(filter);

        filter.isChanged = false;
        return data;
      });
  }

  find(predicate) {
    for (let i = 0; i < this.filters.length; ++i) {
      const filter = this.filters[i];
      const f = filter.find(predicate);
      if (f) {
        return f;
      }
    }
  }

  findById(id) {
    return this.find(f => f.id === id);
  }

  getPath(filter) {
    for (let i = 0; i < this.filters.length; ++i) {
      const f = this.filters[i];
      const path = f.getPath(filter);
      if (path) {
        return path;
      }
    }
    return [];
  }

  getCardFilter(dim) {
    return this.find(filter =>
        filter.isDimensionCard && filter.dimension === dim) ||
      this.getDefaultCardFilter(dim);
  }

  getDefaultCardFilter(dim) {
    dim = dim.split('@')[0];
    return this.find(filter =>
      filter.isDimensionCard && filter.dimension.startsWith(dim));
  }

  onDeleteFilter(filter) {
    const path = this.getPath(filter);
    if (path.length) {
      path.pop().removeChild(filter);
    } else {
      this.filters = this.filters.filter((f) => f.id != filter.id);
    }
  }

  delete(filter) {
    return this.FilterResource.delete(filter)
      .then(({
        status,
        data,
        error
      }) => {
        if (error) {
          this.globalAlert(error.message);
          // return;
        }
        this.onDeleteFilter(filter);
        // this.filters = this.filters.filter((f) => f.id != filter.id);
      })
      .catch((error) => {
        this.globalAlert(error);
      });
  }
}



// WEBPACK FOOTER //
// ./src/core/filters.service.js